<template>
  <div style=""
       :style="{'height': horizontal ? '50px': 'auto','width': !horizontal ? '50px': 'auto','border-right': !horizontal ? '1px solid rgba(0,0,0,0.12)':'0px','border-bottom': horizontal ? '1px solid rgba(0,0,0,0.12)':'0px'}"
       :class="{'layout-column': !horizontal, 'layout-row': horizontal}">

    <v-overlay :value="menu0 || menu1 || menu2 || menu3" opacity="0.7"></v-overlay>

    <div class="flex pa-1" :class="{'layout-row': horizontal}" style="overflow-y: hidden;">

      <v-menu :offset-x="false" :offset-y="false" v-model="menu0">
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on"
               v-bind="attrs">
            <lx-btn classes="mb-1 mr-1"
                    :color="compColor.prime"
                    icon-color="white"
                    icon="mdi-shield-account"
                    tooltip="Aktionen für angemeldeten Benutzer"></lx-btn>
          </div>
        </template>

        <v-list v-bind:class="{'blue-grey darken-3': compColor.isInDarkMode}" style="padding-top: 0;">
          <v-list-item two-line
                       :dark="compColor.isInDarkMode"
                       :style="{'background': compColor.primeColor}">
            <v-avatar style="border:3px solid white;" class="elevation-6">
              <v-icon dark style="box-shadow:0 0 5px rgba(0,0,0,0.5);"> mdi-account-circle</v-icon>
            </v-avatar>
            <v-list-item-content class="ml-3 white--text">
              <v-list-item-title>{{ getUser().firstname }} {{ getUser().lastname }}</v-list-item-title>
              <v-list-item-subtitle>{{ getUser().email }} {{ returnLoginName() }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item two-line
                       :dark="compColor.isInDarkMode"
                       @click="addTabToStore({routeName: 'AccountDetails', options: {headline: 'Account', icon: 'mdi-account-circle'}})">
            <v-list-item-content class="ml-3">
              <v-list-item-title>Account verwalten</v-list-item-title>
              <v-list-item-subtitle>Hier können Sie Änderungen an ihren Accountdaten vornehmen
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-icon :color="compColor.primeColor" class="mx-2">face</v-icon>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="logout" two-line :dark="compColor.isInDarkMode">
            <v-list-item-content class="ml-3">
              <v-list-item-title>Abmelden</v-list-item-title>
              <v-list-item-subtitle>Bitte melden Sie sich immer ordnungsgemäß ab.
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-icon :color="compColor.primeColor" class="mx-2">lock</v-icon>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-divider :vertical="horizontal"
                 class="mb-1 mx-3"
                 style="border-color: transparent;"></v-divider>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsPhysicianOrEmployee"
              @click="addTabToStore({routeName: 'PatientsList', options: {headline: 'Alle Patienten', icon: 'mdi-account-group'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              width="40px"
              icon="mdi-account-group"
              tooltip="Patienten öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsPhysicianOrEmployee"
              @click="addTabToStore({routeName: 'Import', options: {headline: 'Import', icon: 'mdi-file-import'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              width="40px"
              icon="mdi-file-import"
              tooltip="Aktueller Import aus dem AIS"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsPhysician"
              @click="addTabToStore({routeName: 'EmployeesList', options: {headline: 'Mitarbeiter', icon: 'mdi-account-multiple'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              width="40px"
              icon="mdi-account-multiple"
              tooltip="Mitarbeiter anzeigen/verwalten"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsPhysicianOrEmployee"
              width="40px"
              @click="addTabToStore({routeName: 'ReportsList', options: {headline: 'Alle Meldungen', icon: 'mdi-file-document-multiple-outline' }})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-file-document-multiple-outline"
              tooltip="Bisherige Meldungspakete anzeigen"></lx-btn>

      <!--  user is company -->

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsCompany"
              @click="addTabToStore({routeName: 'PhysiciansList', options: {headline: 'Ärzte'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              width="40px"
              icon="mdi-account-multiple"
              tooltip="Ärzte öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsCompany"
              width="40px"
              @click="addTabToStore({routeName: 'Statistics', options: {headline: 'Statistiken', icon: 'mdi-chart-areaspline'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-chart-areaspline"
              tooltip="Statistiken öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsCompany"
              width="40px"
              @click="addTabToStore({routeName: 'InsuranceCompanyList', options: {headline: 'Zusätzliche Krankenkassen', icon: 'mdi-cash-register'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-cash-register"
              tooltip="Zusätzliche Krankenkassen öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsCompany"
              width="40px"
              @click="addTabToStore({routeName: 'DownloadsDetails', options: {headline: 'Downloads', icon: 'mdi-cloud-upload'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-cloud-upload"
              tooltip="Downloads öffnen"></lx-btn>

      <!--  user is admin -->

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin"
              width="40px"
              @click="addTabToStore({routeName: 'CancerRegisterList', options: {headline: 'Krebsregister'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-home-group"
              tooltip="Krebsregister öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin"
              width="40px"
              @click="addTabToStore({routeName: 'CompaniesList', options: {headline: 'Firmen', icon: 'mdi-account-multiple'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-account-multiple"
              tooltip="Firmen öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin"
              width="40px"
              @click="addTabToStore({routeName: 'MaintenanceOverview', options: {headline: 'Wartung', icon: 'mdi-toolbox'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-toolbox"
              tooltip="Wartung öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin"
              width="40px"
              @click="addTabToStore({routeName: 'Statistics', options: {headline: 'Statistiken', icon: 'mdi-chart-areaspline'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-chart-areaspline"
              tooltip="Statistiken öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin || userIsCompany"
              width="40px"
              @click="addTabToStore({routeName: 'NewsList', options: {headline: 'News und Ankündigungen', icon: 'mdi-newspaper-variant-outline'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-newspaper-variant-outline"
              tooltip="News und Ankündigungen öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin"
              width="40px"
              @click="addTabToStore({routeName: 'EncryptionKeysList', options: {headline: 'Schlüsselverwaltung', icon: 'mdi-key-variant'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-key-variant"
              tooltip="Schlüsselverwaltung"></lx-btn>

      <v-divider :vertical="horizontal"
                 class="my-3 mx-3"
                 v-if="userIsAdmin"
                 :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
                 :style="{'border-color': this.compColor.primeHighlightColor}"></v-divider>

      <lx-btn classes="my-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin"
              width="40px"
              @click="addTabToStore({routeName: 'MonitoringUsersList', options: {headline: 'Benutzer', icon: 'mdi-account-group'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-account-group"
              tooltip="Benutzer"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin"
              width="40px"
              @click="addTabToStore({routeName: 'MonitoringMailQueueDetails', options: {headline: 'E-Mail Warteschlange', icon: 'mdi-email-sync-outline'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-email-sync-outline"
              tooltip="E-Mail Warteschlange"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              v-if="userIsAdmin"
              width="40px"
              @click="addTabToStore({routeName: 'MonitoringMetadataDetails', options: {headline: 'Auswertung Benutzerdaten', icon: 'mdi-account-hard-hat'}})"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-account-hard-hat"
              tooltip="Auswertung Benutzerdaten"></lx-btn>

      <!--  all users -->

      <v-divider :vertical="horizontal"
                 class="my-3 mx-3"
                 :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
                 :style="{'border-color': this.compColor.primeHighlightColor}"></v-divider>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              @click="openThemeSidebar"
              icon="mdi-cogs"
              tooltip="Einstellungen öffnen"></lx-btn>

      <lx-btn classes="mb-1 mr-1"
              :color="compColor.nav.contentFrame"
              @click="enterFullscreen()"
              :icon-color="this.isDarkMode || this.isMediumMode ? this.compColor.primeHighlightColor : this.compColor.primeColor"
              icon="mdi-fullscreen"
              tooltip="Vollbildmodus"></lx-btn>

    </div>

    <div style="position: relative;height:200px;">
      <div class="outer-text mt-1 mr-2">
        <div class="font-weight-black white--text inner-text" v-bind:class="{'rotate-text': !horizontal}">
          TumorScout
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.component('lxBtnBar', {
  props: {
    value: [Boolean],
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    },

    label: {
      type: String,
      default: null
    },
    height: {
      type: [Number, String],
      default: 40
    },
    disabled: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    classes: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      menu0: false,
      menu1: false,
      menu2: false,
      menu3: false,
      filteredLayoutTypes: null,
    }
  },
  mounted () {
  },
  created () {
    this.filteredLayoutTypes = this.getLayoutTypes
    delete this.filteredLayoutTypes['3']
  },
  methods: {
    enterFullscreen () {
      const doc = window.document;
      const docEl = doc.documentElement;

      const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
      const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

      if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl);
      } else {
        cancelFullScreen.call(doc);
      }
    },

    // return login name to show in view
    returnLoginName () {
      let returnValue = ''
      const user = this.getUser()

      if (user && user.login_name) {
        returnValue = '(' + user.login_name + ')'
      }
      return returnValue
    }
  },
  computed: {
    horizontal: {
      get () {
        return this.value
      },
      set (value) {
        return this.$emit('input', value)
      }
    },
    authUserName () {
      return this.authStore.getters.getAuthUserName
    },
    authUserTitle () {
      return this.authStore.getters.getAuthUserTitle
    },
    getLocationName () {
      return this.getUser().location_name
    },
    userIsPhysician () {
      return this.authStore.getters.userIsPhysician
    },
    userIsPhysicianOrEmployee () {
      return this.authStore.getters.userIsPhysicianOrEmployee
    },
    userIsCompany () {
      return this.authStore.getters.userIsSystemadmin
    },
    userIsAdmin () {
      return this.authStore.getters.userIsAdmin
    }
  }
})
</script>

<style scoped lang="scss">

.v-list-item--dense, .v-list--dense .v-list-item {
  min-height: 30px;
  min-width: 40px;
}

.v-menu__content.theme--light.menuable__content__active {
  min-width: auto !important;

  .v-list.speedMenu {
    padding: 0;

    .v-list-item {
      padding: 4px;
    }
  }
}

.lx-square {
  min-width: 40px;
  width: 40px;
  min-height: 35px !important;
}

.lx-btn {
  &:not(.v-btn--round).v-size--default {
    min-width: 2em;
  }
}

.lx-btn.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: inherit; //#272b36;
}

.v-subheader {
  font-size: 13px;
}

.v-btn.v-btn--small {
  padding: 0 4px !important;
}

.lxpager {
  margin: 2px 2px;
  padding: 6px 6px;
  color: #000;
  cursor: pointer;
}

.lxpager.disabled {
  color: #CCC;
}

.v-btn {
  min-width: auto;

  &.btn--small {
    max-width: 28px;
  }
}

.list__tile__content.pagesize-is-active {
  .list__tile__title {
    font-weight: bold;
    color: #00bfa5;
  }
}

.v-list-item__content {
  padding: 0 !important;
}
</style>
